<template>
  <v-container fluid fill-height class="login-background">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4" align="center" justify="center">
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{ $t("ForgotPassword.Title") }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                prepend-icon="mdi-email"
                name="mail"
                :label="$t('Generic.Mail')"
                type="text"
                v-model="mail"
                :rules="[rules.required, rules.email]"
                v-on:keyup.enter="SendResetRequest"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              v-on:click="SendResetRequest"
              :disabled="!valid"
              :loading="isRequesting"
              >{{ $t("ForgotPassword.Request_reset") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AuthService from "@/services/AuthenticationService";

export default {
  data() {
    return {
      valid: false,
      isRequesting: false,
      mail: "",
      rules: {
        required: value => !!value || this.$i18n.t("Rules.Mail_required"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$i18n.t("Rules.Mail_invalid");
        }
      }
    };
  },
  methods: {
    SendResetRequest() {
      if (this.$refs.form.validate()) {
        this.isRequesting = true;
        let request = {
          Mail: this.mail
        };

        AuthService.RequestPasswordChange(request)
          .then(response => {
            this.$emit("show-success", this.$i18n.t("Success.Change_request"));
            this.$router.push({ name: "Login" });
          })
          .catch(error =>
            this.$emit("show-error", this.$i18n.t("Error.Request_Reset_Failed"))
          )
          .finally(() => (this.isRequesting = false));
      }
    }
  }
};
</script>

<style scoped>
.login-background {
  background-image: url(../assets/login_background.jpg);
  background-size: cover;
}
</style>
